// extracted by mini-css-extract-plugin
export default {"wrapper":"Marketplace_wrapper__ZIm3z","container":"Marketplace_container__56L7m"};